module.exports = __webpack_public_path__ + "img/onhold.cd91b120.svg";